import {Confirm, useOpenModal} from '@/components/Modal/index.mjs'

export const usePluginUndoReviseProduct = () => {
    const openModal = useOpenModal()

    const extensions = () => {
        return {
            canUndoReviseProduct() {
                if (! this.permission.has('write')) {
                    this.logger.error('没有撤销修订权限')
                    return false
                }

                const bn = this.BizNode[this.componentType ?? this.productType]

                if ('function' !== typeof bn.publish) {
                    this.logger.error('不支持撤销修订')
                    return false
                }

                const {stsCode} = this.root.data

                if ('REVISE' !== stsCode) {
                    this.logger.error('只有修订状态才能撤销修订')
                    return false
                }

                return true
            },

            async cmdUndoReviseProduct() {
                await this.runAction(
                    () => this.execute(
                        () => this.undoReviseProduct()
                    ),

                    {action: '撤销修订模型制品'},
                )
            },

            async undoReviseProduct() {
                const isConfirmed = await openModal(
                    <Confirm>
                        确定撤销修订？（撤销修订后，模型将恢复至最近一次发布版）
                    </Confirm>
                )

                if (! isConfirmed) {
                    return
                }

                const bn = this.BizNode[this.componentType ?? this.productType]
                await bn.undoRevise(this, this.root)
                this.resetChangeHistory()
            },

            useCanUndoReviseProduct() {
                this.usePermission()
                this.useNodeChange(this.root, ['data'])
                return this.canUndoReviseProduct()
            },
        }
    }

    return {extensions}
}
